 import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import "../css/admin.css";
import AdminSidebar from "../components/AdminSidebar";
function AdminFeaturedProducts() {

    const [products, setProducts] = useState([]);

    const token = localStorage.getItem("token");

    const loadProducts = () => {

        axios.get(
            `${API_URL}/admin/featured-products`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        .then((res) => {
            setProducts(res.data);
        })
        .catch((err) => {
            console.log(err);
        });

    };

    useEffect(() => {
        loadProducts();
    }, []);

    const toggleFeatured = (id, currentValue) => {

        axios.put(
            `${API_URL}/admin/featured-products/${id}`,
            {
                is_featured: currentValue ? 0 : 1
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        .then(() => {
            loadProducts();
        })
        .catch((err) => {
            console.log(err);
        });

    };

   return (

    <div className="admin-layout">

        <AdminSidebar />

        <div className="admin-content">

            <h2>⭐ Featured Products</h2>

            <table className="admin-table">

                <thead>

                    <tr>
                        <th>Image</th>
                        <th>Product</th>
                        <th>Category</th>
                        <th>Price</th>
                        <th>Featured</th>
                    </tr>

                </thead>

                <tbody>

                    {products.map((product) => (

                        <tr key={product.id}>

                            <td>

                                <img
                                    src={`http://localhost:5000${product.image}`}
                                    alt={product.product_name}
                                    width="60"
                                />

                            </td>

                            <td>{product.product_name}</td>

                            <td>{product.category}</td>

                            <td>${product.price}</td>

                            <td>

                                <input
                                    type="checkbox"
                                    checked={product.is_featured === 1}
                                    onChange={() =>
                                        toggleFeatured(
                                            product.id,
                                            product.is_featured
                                        )
                                    }
                                />

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>
        </div>

    );

}

export default AdminFeaturedProducts;